import {createSlice} from '@reduxjs/toolkit';

interface IMerchantData {
  seedflexMId: string | number;
  id: string | number;
  name: string;
  merchantName: string;
  merchantBusinessName: string;
  partnerName: string;
  partnerIdentifier: string | number;
  currency: string;
  smeMaskedId: string | number;
  mpId: string | number;
}

interface ILimitData {
  id: number;
  finalAvailableLimit: number;
  limitStatus: string;
}

interface IOverrideData {
  loanType: 'FIXED' | 'FLEXI';
  minLimit: number;
  maxLimit: number;
  salesMultiplier: number;
  avgWeeklyRevenueAmt: number;
  feePercent: number;
  minimumPaymentPeriod: number;
  expectedMaxTenure: number;
  minDsr: number;
  maxDsr: number;
  programId: number;
  reason: string;
  transactionType: 'SETTLEMENT' | 'SALES' | 'BANK_STATEMENT';
  productType: 'STEPIN' | 'REGULAR';
}

export interface IPreviewData {
  finalAvailableAmount: number;
  averageWeeklySales: number;
  expectedMaxTenure: number;
  currency: string;
  enabledLoanType: 'FIXED' | 'FLEXI';
  actionCode: number;
  actionDescription: string;
  maxDsr: number;
  usedDsr: number;
  availableDsr: number;
  availableLimitDsrBased: number;
  maxLimit: number;
  usedLimit: number;
  availableLimit: number;
  maxInstallmentAmount: number;
  usedInstallmentAmount: number;
  availableInstallmentAmount: number;
  availableLimitInstallmentBased: number;
  maxDailyRepaymentAmt: number;
  minRepaymentAmtPerMonth: number;
}

interface INewLimit {
  input: 'businessName' | 'seedflexMId';
  merchantData: IMerchantData | null;
  limitData: ILimitData | null;
  overrideData: IOverrideData | null;
  previewNewLimit: IPreviewData | null;
}

const initialState: INewLimit = {
  input: 'businessName',
  merchantData: null,
  limitData: null,
  overrideData: null,
  previewNewLimit: null,
};

const newLimit = createSlice({
  name: 'newLimit',
  initialState,
  reducers: {
    setInput(state, actions) {
      state.input = actions.payload;
    },
    setMerchantData(state, actions) {
      state.merchantData = actions.payload;
    },
    setLimitData(state, actions) {
      state.limitData = actions.payload;
    },
    setOverrideData(state, actions) {
      state.overrideData = actions.payload;
    },
    setPreviewNewLimit(state, actions) {
      state.previewNewLimit = actions.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

const newLimitReducer = newLimit.reducer;

export const newLimitActions = newLimit.actions;

export default newLimitReducer;
